import * as React from 'react';
import styled from 'styled-components';
import BREAK_POINTS from '../../../../styling/media-queries';
import getPartnerAsset, { DynamicAssetsKeys } from '../../../../assets';

const Container = styled.div`
  margin-top: 60px;
  margin-left: 20px;
  margin-right: 20px;
  text-align: center;
  @media ${BREAK_POINTS.mobileBig} {
    margin-left: 40px;
    margin-right: 40px;
  }
`;

const Secondary = styled.div`
  font-weight: normal;
  font-size: 28px;
  line-height: 32px;
  color: #1b1b1b;
  @media ${BREAK_POINTS.mobile} {
    font-size: 22px;
    line-height: 22px;
  }
`;

const Heading: React.FC<any> = getPartnerAsset(DynamicAssetsKeys.calculatorResultsHeadingComponent);

const CalculatorResultsOverview: React.FC = () => (
  <Container>
    <Heading>{getPartnerAsset(DynamicAssetsKeys.calculatorResultsHeading)}</Heading>
    <Secondary>{getPartnerAsset(DynamicAssetsKeys.calculatorResultsSubheading)}</Secondary>
  </Container>
);

export default CalculatorResultsOverview;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/calculator/results/components/CalculatorResultsOverview.tsx